<template>
  <modal @close="modals.notecardModal = false" width="1000">
    <h3>Campaign Notecards</h3>
    <div id="notecard-panel" class="notecard-panel-modal">
      <div id="notecard-panel-left">
        <h5>Campaign Notecard Text</h5>
        <p v-if="panelType='gifting-campaign-detail'">A notecard with text provided below will be automatically attached to all packages sent via this campaign, unless specified otherwise.</p>
        <div v-if="!enabled" class="small-note error"><span>WARNING:</span> Your notecard is disabled. To add or change its text, enable it first. When your notecard is disabled, it won't be automatically attached to campaign gifts.</div>
        <div v-if="panelType='gifting-campaign-detail'" class="small-note"><span>NOTE:</span> When using the <i>Select & Send</i> or <i>Invite People</i> tool, you can customise the notecard
text individually for each recipient.</div>
        <textarea v-if="enabled" v-model="text" id="notecard-text" name="notecard-text" rows="6" maxlength="1015"></textarea>
        <div v-if="enabled" id="notecard-price">
          Unit Price: <b>£1.00</b> <i>(Excluding VAT)</i>
          <small>Notecard price will be charged for each package that includes notecard.</small>
        </div>
      </div>
      <div id="notecard-panel-right" class="notecard-preview-component">
        <h5>Notecard Preview</h5>
        <div v-if="design" id="notecard-rotator" :class="previewSide">
          <div class="notecard-rotate front" @click="flip('front')">Front Side</div>
          <div class="notecard-rotate back" @click="flip('back')">Back Side</div>
        </div>
        <div id="notecard-preview" :side="previewSide">
          <div v-if="previewSide=='front'" class="notecard-preview-side" id="notecard-front-side">
            <div class="notecard-preview-text">{{ text }}</div>
          </div>
          <div v-if="previewSide=='back'" class="notecard-preview-side" id="notecard-back-side" :style="'background-image: url('+design+')'"></div>
        </div>
      </div>
    </div>
    <div class="form-actions">
      <div v-if="enabled" class="ws-button ws-button-primary" @click="saveNotecard()">SAVE CHANGES</div>
      <div v-if="enabled" class="ws-button ws-button-negative" @click="enableNotecard(false)">DISABLE NOTECARD</div>
      <div v-if="!enabled" class="ws-button" @click="enableNotecard(true)">ENABLE NOTECARD</div>
      <div class="ws-button ws-button-secondary" data-action="cancel" @click="modals.notecardModal = false">GO BACK</div>        
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "NotecardModal.vue",
    components: {Modal},
    props: ['type','enabled','text','design'],
    data() {
        return {
            defaultType: 'gifting-campaign-detail', 
            previewSide: 'front'
        }
    },
    methods: {
        flip(side) {
          this.previewSide = side;
        },
        async saveNotecard() {
          if (!this.demoCheck()) return;
          
          const formData = new FormData();
          formData.append('notecard_text', this.text);
          if (this.panelType=='gifting-campaign-detail') {
            await this.dispatchWaitAndNotify('updateGiftBoxCampaign', {campaignId: this.$parent.item.id, payload: formData});
            await this.dispatchWaitAndNotify('fetchGiftBoxCampaign',  {campaignId: this.$route.params.id, params: {with_option_counts:true}}, false, true);
            this.modals.notecardModal = false;
          }
        },
        async enableNotecard(status) {
          if (!this.demoCheck()) return;
          
          const formData = new FormData();
          formData.append('notecard_enabled', status);
          if (this.panelType=='gifting-campaign-detail') {
            await this.dispatchWaitAndNotify('updateGiftBoxCampaign', {campaignId: this.$parent.item.id, payload: formData});
            await this.dispatchWaitAndNotify('fetchGiftBoxCampaign',  {campaignId: this.$route.params.id, params: {with_option_counts:true}}, false, true);
          }
        }
    },
    mounted() {
        if (!this.proCheck('Setting and editing notecards')) {
            this.modals.notecardModal = false;
            return;
        }
    },
    created() {
    },
    beforeDestroy() {
    },
    computed: {
        modals() {
            return this.$store.state.modals;
        },
        panelType() {
            return this.type ? this.type : this.defaultType;
        },
    },
    watch: {
        'text': {
            handler (text) {
                // NOTE: this.clearEmojis() doesn't exist, commented out because it was breaking down js
                //this.text = this.clearEmojis(text);
            },
        },
    },
}
</script>